import {inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import {
  ChangePasswordRequest,
  ClientSettingsModel,
  UpdateClientSettingsRequest
} from '../models/settings.model';

@Injectable({providedIn: 'root'})
export class SettingsService {
  private readonly http = inject(HttpClient);
  private readonly settingsUrl = `${environment.apiUrl}/api/settings`;

  getSettings(): Observable<ClientSettingsModel> {
    return this.http.get<ClientSettingsModel>(this.settingsUrl);
  }

  updateClient(request: UpdateClientSettingsRequest): Observable<ClientSettingsModel> {
    return this.http.put<ClientSettingsModel>(`${this.settingsUrl}/client`, request);
  }

  changePassword(request: ChangePasswordRequest): Observable<void> {
    return this.http.put<void>(`${this.settingsUrl}/password`, request, {withCredentials: true});
  }
}
